rdefine('app/formular/components/frm/Textarea',['backbone','app/formular/components/BaseEditForm','text!formular/frm.textarea.html'],function(Backbone,BaseEditForm,tPlaceholder) {
    return BaseEditForm.extend({
        init:function() {
            this.$sel=this.$el.find(".card-body");
            this.$sel.html(Template7.compile(tPlaceholder)());
        }
    });
});